import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { NumericFormat } from "react-number-format";
import { getDateKey } from "@repo/structure";
import { MaxTimeModifiers } from "@repo/utils";
import { useEstimateStructure } from "@tools";
import { getTimelineCellPeriods } from "@tools/EstimateEditor/utils";
import { TimelineVirtualCell } from "../../TimelineCells";
import useStyle from "./TimelineTotalDistributionRow.style";
import classnames from "classnames";

export const TimelineTotalDistributionRow = observer(() => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const classes = useStyle();

  const {
    usedRoundDecimals,
    usedThousandSeparator,
  } = structure.settings;

  const months = structure.currentTimeline?.totalDistribution || [];
  const expandedMonths = structure.settings.timelineExpandedMonths;

  return (
    <div className={classes.root}>
      {months.map((month) => (
        <TimelineVirtualCell key={getDateKey(month.startDate)} month={month}>
          <div className={classes.periods}>
            {getTimelineCellPeriods(month, expandedMonths).map((period) => (
              <div
                key={getDateKey(period.startDate)}
                className={classnames(classes.cell, "text-lighter text-sm")}
              >
                <NumericFormat
                  displayType="text"
                  value={period.value / MaxTimeModifiers.HOUR}
                  thousandSeparator={usedThousandSeparator}
                  decimalSeparator="."
                  suffix={t("times.h")}
                  decimalScale={usedRoundDecimals}
                  valueIsNumericString
                />
              </div>
            ))}
          </div>
        </TimelineVirtualCell>
      ))}
    </div>
  );
});
